module.exports = __webpack_public_path__ + "static/media/CrownGold.5ea9d5ba.png";